import { render, staticRenderFns } from "./serviceCompany_cn.vue?vue&type=template&id=a2e5620e"
import script from "./serviceCompany_cn.vue?vue&type=script&lang=js"
export * from "./serviceCompany_cn.vue?vue&type=script&lang=js"
import style0 from "./serviceCompany_cn.vue?vue&type=style&index=0&id=a2e5620e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports